import types from 'redux/types';
import { checkTypeValue } from 'helpers';

const {
  REQUEST_MANAGE_USER,
  REQUEST_MANAGE_USER_SUCCESS,
  REQUEST_MANAGE_USER_FAILED,
  REQUEST_CHANGE_USER,
  REQUEST_CHANGE_USER_FAILED,
} = types;

const initialState = {
  isFetching: false,
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case REQUEST_MANAGE_USER: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case REQUEST_MANAGE_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: actions.data,
      };

    case REQUEST_MANAGE_USER_FAILED:
      return {
        ...state,
        isFetching: false,
        error: actions.error,
      };

    case REQUEST_CHANGE_USER:
      return {
        ...state,
        isSwitching: true,
      };

    case REQUEST_CHANGE_USER_FAILED:
      return {
        ...state,
        isSwitching: false,
      };

    default:
      return state;
  }
};
